export class MaterialAndQualityDto {
    constructor(
        public material :string,
        public quality :string,
        public customerLineNumber:string,
    ){

    }
}
